<template>
    <div class="content-box" style="background-color: #fbfbfb">
         <div class="content">
             <div class="title-box">
                 <div class="title">
                     <div class="title-text">场站运维</div>
                     <div class="title-e">STATION MAINTENANCE</div>
                     <div class="title-line"></div>
                 </div>
             </div>
             <div class="describe">
                 通过极能充平台提供的安防监控系统，可有效预防各类事故发生，维护人生、财产安全、保证充电设施安全稳定进行。专业维护团队7*24小时线上线下服务，实现场站无人值守自动化运营。
             </div>
             <div class="describe-row">
                 <div class="row-item">
                     <span class="icon-img icon41"></span> 平台信息化支撑
                 </div>
                 <div class="row-item">
                     <span class="icon-img icon43"></span> 智能远程监控
                 </div>
             </div>
             <div class="describe-row">
                 <div class="row-item">
                     <span class="icon-img icon42"></span>
                     充电主动预警
                 </div>
             </div>
             <div class="data-describe">
                 <div class="data-box data-one">
                     <div class="data-num">7*24<span  class="min-span">小时</span></div>
                     <div class="data-synopsis">
                         <p>提供线上线下服务</p>
                     </div>
                 </div>
                 <div class="data-line"></div>
                 <div class="data-box data-t">
                     <div class="data-num">99<span class="min-span">%</span></div>
                     <div class="data-synopsis">
                         <p>充电桩可靠率99%以上</p>
                     </div>
                 </div>
             </div>
             <div class="img-describe img4"></div>
         </div>
    </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  methods: {},
}
</script>
<style src="./i_public.less" lang="less" scoped></style>
<!--<style lang="less" scoped>-->
    <!--.content-box{-->
        <!--width: 100%;-->
        <!--margin: 0px auto;-->
        <!--height: 100%;-->
        <!--background-color: #fbfbfb;-->
        <!--font-family:PingFangSC-Regular,PingFang SC;-->
        <!--.content{-->
            <!--width: 1200px;-->
            <!--height: 600px;-->
            <!--margin: 0px auto;-->
            <!--padding:20px;-->
            <!--position: relative;-->
            <!--.title-box{-->
                <!--display: flex;-->
                <!--justify-content: space-between;-->
                <!--font-size: 20px;-->
                <!--width: 1000px;-->
                <!--margin: 2% auto;-->
                <!--height: 66px;-->
                <!--text-align: left;-->
                <!--.title-text {-->
                    <!--color: #05123E;-->
                    <!--font-size: 30px;-->
                    <!--font-weight: 500;-->
                <!--}-->
                <!--.title-e {-->
                    <!--font-size: 10px;-->
                    <!--color: #6684D0;-->
                    <!--line-height: 30px;-->
                    <!--letter-spacing: 1px;-->
                <!--}-->
                <!--.title-line {-->
                    <!--background: linear-gradient(90deg,  #099AFF, #3AFEFE);-->
                    <!--height: 2px;-->
                    <!--width: 30px;-->
                    <!--margin: 0 auto;-->
                    <!--border-radius: 1px;-->
                    <!--margin-left: 0;-->
                <!--}-->
                <!--.end-rukou{-->
                    <!--font-size: 14px;-->
                    <!--color: #19C1E7;-->
                    <!--text-align: right;-->
                    <!--line-height: 66px;-->
                    <!--.icon-img{-->
                        <!--background-image: url('./../../../assets/icon_next 2@2x.png');-->
                        <!--display: inline-block;-->
                        <!--width: 24px;-->
                        <!--height: 24px;-->
                        <!--background-repeat: no-repeat;-->
                        <!--background-size: 24px 24px;-->
                        <!--margin-bottom: -6px;-->
                    <!--}-->
                <!--}-->
            <!--}-->
            <!--.describe{-->
                <!--width: 1000px;-->
                <!--margin: 0 auto;-->
                <!--text-align: left;-->
                <!--color: #526BAB;-->
                <!--font-size: 16px;-->
                <!--line-height: 30px;-->
            <!--}-->
            <!--.describe-characteristic{-->
                <!--width: 1000px;-->
                <!--margin: 10px auto;-->
                <!--text-align: left;-->
                <!--color: #1A3068;-->
                <!--font-size: 14px;-->
                <!--line-height: 28px;-->
                <!--.icon-img{-->
                    <!--display: inline-block;-->
                    <!--width: 24px;-->
                    <!--height:24px;-->
                    <!--margin-right: 6px;-->
                    <!--background-repeat: no-repeat;-->
                    <!--background-size: 24px 24px;-->
                    <!--margin-bottom: -6px;-->
                <!--}-->
                <!--.icon1{-->
                    <!--background-image: url('./../../../assets/a.png');-->
                <!--}-->
                <!--.icon2{-->
                    <!--background-image: url('./../../../assets/b.png');-->
                <!--}-->
                <!--.icon3{-->
                    <!--background-image: url('./../../../assets/icon_chongdian4_c@2x.png');-->
                <!--}-->
                <!--.icon4{-->
                    <!--background-image: url('./../../../assets/icon_chongdian4_d@2x.png');-->
                <!--}-->
            <!--}-->
            <!--.data-describe{-->
                <!--width: 1000px;-->
                <!--margin: 20px auto;-->
                <!--display: flex;-->
                <!--.data-box{-->
                    <!--width: 170px;-->
                    <!--height:120px;-->
                    <!--padding:10px;-->
                    <!--.data-num{-->
                        <!--color: #19C1E7;-->
                        <!--font-size: 32px;-->
                    <!--}-->
                    <!--.data-synopsis{-->
                        <!--font-size: 14px;-->
                        <!--line-height: 10px;-->
                        <!--font-family:PingFangSC-Regular,PingFang SC;-->
                        <!--font-weight:400;-->
                        <!--color:rgba(26,48,104,1);-->
                    <!--}-->
                <!--}-->
                <!--.data-line{-->
                    <!--min-width: 1px;-->
                    <!--height: 50px;-->
                    <!--background-color: #E6E9F3;-->
                    <!--margin-top: 20px;-->
                <!--}-->

            <!--}-->
            <!--.img-describe{-->
                <!--height: 360px;-->
                <!--width: 376px;-->
                <!--background-image: url('./../../../assets/yunwei.gif');-->
                <!--background-repeat: no-repeat;-->
                <!--background-size: 80%;-->
                <!--position: absolute;-->
                <!--bottom: 80px;-->
                <!--right: 60px;-->
            <!--}-->
        <!--}-->
    <!--}-->

    <!--@media screen and (max-width: 1100px) {-->
        <!--.img-describe{-->
            <!--background-size: 60%!important;-->
            <!--right: -40px!important;-->
        <!--}-->
    <!--}-->
    <!--@media screen and (max-width: 1000px) {-->
        <!--.img-describe{-->
            <!--background-size:45%!important;-->
            <!--height: 260px;-->
            <!--width: 264px;-->
            <!--bottom: 70px!important;-->
            <!--right:-100px!important;-->
        <!--}-->
    <!--}-->
    <!--@media screen and (max-width: 800px) {-->
        <!--.img-describe{-->
            <!--display: none;-->
        <!--}-->
    <!--}-->








<!--</style>-->